import React, { useEffect, useState } from "react";
import Header from "../components/ProductCondition/Header";
import SearchState from "../components/strengthAnalysis/SearchState";
import Table from "../components/strengthAnalysis/Table";
import ChartComponent from "../components/strengthAnalysis/ChartComponent";
import axios from "axios";
import config from "../config";
import { getYearMonth } from "../util/date";
import PaperChartComponent from "../components/strengthAnalysis/PaperChartComponent";
import { orderByBsswgh } from "../util/util";

const PaperKind = () => {
  const date = new Date();
  const [resbody, setResbody] = useState();
  const [reqData, setReqData] = useState({
    STDATE: getYearMonth(new Date(date.setMonth(date.getMonth() - 1))),
    ENDATE: getYearMonth(new Date()),
    PKCDXX: "",
    BSSWGH: "",
  });
  const [secondHogiGraphData, setSecondHogiGraphData] = useState();
  const [thirdHogiGraphData, setThirdHogiGraphData] = useState();
  const [newResbodyForm, setNewResbodyForm] = useState([]);

  const handleNewDataFrom = (data) => {
      let response = [...data];
      let currentPKCDXX = "";
      let currentBSSWGH = "";
      let returnArr = [];
      while(response.length > 0) {
        currentPKCDXX = response[0].PKCDXX;
        currentBSSWGH = response[0].BSSWGH;
        let findData = response.filter((e) => e.PKCDXX === currentPKCDXX && e.BSSWGH === currentBSSWGH);
        if(findData.length < 2) {
          returnArr.push(
            {
              PKCDXX: currentPKCDXX,
              BSSWGH: currentBSSWGH,
              data: {
                  [`${findData[0].HOGIXX}_CDINDX`]: findData[0].CDINDX,
                  [`${findData[0].HOGIXX}_PAINDX`]: findData[0].PAINDX
                }
            });
        } else {
          returnArr.push(
            {
              PKCDXX: currentPKCDXX,
              BSSWGH: currentBSSWGH,
              data: {
                  [`${findData[0].HOGIXX}_CDINDX`]: findData[0].CDINDX,
                  [`${findData[0].HOGIXX}_PAINDX`]: findData[0].PAINDX,
                  [`${findData[1].HOGIXX}_CDINDX`]: findData[1].CDINDX,
                  [`${findData[1].HOGIXX}_PAINDX`]: findData[1].PAINDX,
                }
            });
        }
        response = response.filter((e) => {
          return e.PKCDXX !== currentPKCDXX || e.BSSWGH !== currentBSSWGH
        })
      }
      returnArr = setMinLength(returnArr);
      return returnArr;
  }
  const setMinLength = (arr) => {
    const result = [...arr];
    const minlength = 12;
    for(let i = result.length; i < minlength; i++) {
      result.push({});
    }
    return result
  }

  const handleSearch = async () => {
    try {
      const res = await axios({
        url: `${config.apiUrl}/jospMJP.do`,
        method: 'POST',
        data: {
          stdate: reqData.STDATE,
          endate: reqData.ENDATE,
          pkcdxx: reqData.PKCDXX,
          bsswgh: reqData.BSSWGH
        }
      })
      const sortedRes = orderByBsswgh(res.data.resultData[res.data.resultCount - 1].data)
      setNewResbodyForm(handleNewDataFrom(sortedRes));

      setSecondHogiGraphData(sortedRes.filter(v => v.HOGIXX === '2'))
      setThirdHogiGraphData(sortedRes.filter(v => v.HOGIXX === '3'))
      console.log("resbody", sortedRes)
      setResbody (sortedRes);
      
    } 
    catch(err) {
      console.log(err)
      alert("조회된 데이터가 없습니다.")
      setNewResbodyForm(setMinLength([]))
      setSecondHogiGraphData([])
      setThirdHogiGraphData([])
    }
  }
  useEffect(() => {
    handleSearch();
  }, [])

  return (
    <div className="bg-blue-200 min-h-screen flex-col flex">
      <Header title={"지종별 조습 품질 분석 조회"}/>
      <SearchState requestData={reqData} setRequestData={setReqData} onclick={handleSearch}/>
      {
        newResbodyForm &&
        <Table data={newResbodyForm}/>
      }
      <div className="w-[90%] max-h-[19rem] ml-3 py-4">
        {
          secondHogiGraphData &&
          <PaperChartComponent data={secondHogiGraphData}/>
        }
        {
          thirdHogiGraphData &&
          <PaperChartComponent data={thirdHogiGraphData}/>
        }
      </div>
    </div>
  )
}

export default PaperKind;